import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";
import moment from "moment";

const apiUrl = `${settings.apiUrl}api/`;

export const requestAll = () =>
  axios.post(`${apiUrl}zones/list`, {
    criteria: [
      {
        fieldName: "end",
        fieldValue: moment()
          .valueOf(),
        searchOperation: filterTypes.MORE.value
      }
    ]
  });

export const requestTemplates = () =>
  axios.post(`${apiUrl}zones/list`, {
    criteria: [{
      fieldName: "template",
      fieldValue: true,
      searchOperation: filterTypes.EQUALS.value
    }]
  });

export const requestZoneTypes = () =>
  axios.get(`${apiUrl}zones/types`);

export const requestAdd = data =>
  axios.post(`${apiUrl}zones`, data);



// WEBPACK FOOTER //
// ./src/actions/zone/requests.js